import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import Cookie from 'js-cookie'

import { LoadingIcon } from '../../components'
import { setActiveStep } from '../../store/modules/guidedSearch.module'
import chevronIcon from '../../assets/icons/chevron-up.svg'
import './GuidedSearchSidebar.sass'


const COOKIE_NAME = 'guided-search-sidebar-tooltip'

const stepToolTip = (
  <ReactTooltip
    id="step-hint"
    place="right"
    effect="solid"
  >
    You can go back to edit your answers by clicking the circles
  </ReactTooltip>
)

class GuidedSearchSidebar extends Component {
  constructor() {
    super()
    this._renderSteps = this.renderSteps.bind(this)
    this._selectStep = this.selectStep.bind(this)
  }

  selectStep(stepIdx, activeStepIdx) {
    // if (stepIdx >= activeStepIdx) { return }

    this.props.setActiveStep(stepIdx)
  }

  componentDidUpdate() {
    const { activeStepIdx } = this.props
    const cookie = Cookie.get(COOKIE_NAME)

    // Display helper tooltip when user goes to second step for the first time
    if (!cookie && activeStepIdx === 1) {
      // Set cookie so we don't display this again
      Cookie.set(COOKIE_NAME, 'val')

      // Display tooltip
      const tooltipNode = findDOMNode(this.refs.tooltip)
      ReactTooltip.show(tooltipNode)
      setTimeout(() => ReactTooltip.hide(tooltipNode), 3500)  // hide after x seconds
    }
  }

  renderSteps(steps) {
    const { isExpanded, activeStepIdx } = this.props

    // Attach a helper tooltip to the first step
    return steps.map((step, idx) => {
      const tooltipAttrs = {}

      if (idx === 0) {
        tooltipAttrs['data-tip'] = ''
        tooltipAttrs['data-for'] = 'step-hint'
        tooltipAttrs['ref'] = 'tooltip'  // used as hook to trigger tooltip
        tooltipAttrs['data-event'] = 'focus'
      }

      return (
        <button className="step-btn" key={idx} onClick={() => this._selectStep(idx, activeStepIdx)}>
          <span
            className={`step-label ${idx === activeStepIdx ? 'active-step' : ''} ${step.isDirty ? 'dirty-step' : ''}`}
            {...tooltipAttrs}
          >
            {idx < steps.length - 1 ? step.order : '='}
          </span>
          <span className="step-name">{isExpanded ? step.step_title : ''}</span>
          {/* tooltip only for first step button */}
          { idx === 0 && stepToolTip }
        </button>
      )
    })
  }

  render() {
    const { isExpanded, toggleSidebar, steps, matches } = this.props

    if (steps.isLoading || !steps.data) {
      return null
    }

    const showExactMatchesCount = matches.matchesCount || !matches.relevantCount
    const matchesCount = matches.matchesCount || 0

    return (
      <React.Fragment>
        <div key={0} className={`guided-search-sidebar ${isExpanded ? 'is-expanded' : ''}`}>
          <nav role="navigation">{this._renderSteps(steps.data)}</nav>
          <div
            className="sidebar-results"
            onClick={() => this.props.setActiveStep(steps.data.length - 1)}
            role="button"
            aria-label="skip to results"
          >
            <h6 className="text-upper sidebar-results-label">
              {showExactMatchesCount ? 'Tool Matches' : 'Relevant Matches'}
            </h6>
            <h1 className="sidebar-results-count">
              {showExactMatchesCount ? matchesCount : matches.relevantCount}
            </h1>
            { isExpanded && <h6 className="text-upper sidebar-results-total">&nbsp; of {matches.totalCount || 0}</h6> }
          </div>
        </div>
        <button
          key={1}
          type="button"
          aria-label="toggle sidebar"
          className="guided-search-sidebar-toggle-btn"
          onClick={toggleSidebar}
        >
          <img src={chevronIcon} alt="toggle sidebar arrow"/>
        </button>
      </React.Fragment>
    )
  }
}

GuidedSearchSidebar.propTypes = {
  isExpanded: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  steps: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.array
  }),
  matches: PropTypes.shape({
    matchesCount: PropTypes.number,
    totalCount: PropTypes.number
  })
};

const mapStateToProps = state => ({
  activeStepIdx: state.guidedSearch.activeStepIdx,
  steps: state.guidedSearch.steps,
  matches: state.filteredSearch.matches
})

export default connect(mapStateToProps, { setActiveStep })(GuidedSearchSidebar);
